import React, { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Drawer, List, ListItemText, Typography, ListItemButton, Avatar, useTheme } from '@mui/material';
import { ReactComponent as KindergartensIcon } from '../assets/kindergarten-icon.svg';
import { ReactComponent as InfoboardIcon } from '../assets/infoboard-icon.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { INFOBOARD, KINDERGARTENS } from '../common/constants/routes.constants';
import { useUserStore } from '../store/useUserStore';

const menuItems = [
  {
    label: 'Kindergartens',
    route: KINDERGARTENS,
    icon: <KindergartensIcon style={{ width: 24, height: 24 }} />
  },
  {
    label: 'Infoboard',
    route: INFOBOARD,
    icon: <InfoboardIcon style={{ width: 24, height: 24 }} />
  }
];

const Sidebar: React.FC = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const { userInfo } = useUserStore();

  const [userInitials, setUserInitials] = useState('');
  const [userFullName, setUserFullName] = useState('');
  const [userCurrentRole, setUserCurrentRole] = useState('');

  useEffect(() => {
    if (userInfo) {
      setUserInitials((userInfo?.user.firstName?.charAt(0).toUpperCase() || '') + (userInfo?.user.lastName?.charAt(0).toUpperCase() || ''));
      setUserFullName(userInfo?.user.firstName + ' ' + userInfo?.user.lastName);
      setUserCurrentRole(userInfo?.isAdmin ? 'Admin' : userInfo?.isSuperAdmin ? 'Superadmin' : '');
    }
  }, [userInfo]);

  const onLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Drawer variant="permanent" anchor="left">
      <Box
        sx={{
          p: 3,
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 4
          }}
        >
          {userInitials && <Avatar sx={{ mr: 1, bgcolor: theme.palette.primary.light }}>{userInitials}</Avatar>}
          <Box>
            <Typography variant="subtitle1">{userFullName}</Typography>
            <Typography sx={{ color: '#B5BCC4' }}>{userCurrentRole}</Typography>
          </Box>
        </Box>

        <List>
          {menuItems.map(({ label, route, icon }) => {
            const isSelected = location.pathname === route;

            return (
              <ListItemButton key={label} onClick={() => navigate(route)} selected={isSelected}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {icon}
                  <ListItemText
                    primary={label}
                    slotProps={{
                      primary: {
                        sx: { color: 'white' }
                      }
                    }}
                  />
                </Box>
              </ListItemButton>
            );
          })}
        </List>

        <Box sx={{ mt: 'auto' }}>
          <ListItemButton onClick={onLogout}>
            <ListItemText
              primary="Logout"
              slotProps={{
                primary: {
                  sx: { color: 'white' }
                }
              }}
            />
          </ListItemButton>
        </Box>
      </Box>
    </Drawer>
  );
};

export default Sidebar;
